import React from "react";

// Components
import { IonButton } from "@ionic/react";

// Styling
import "./Button.scss";

const Button = (props: any) => (
  <IonButton expand="block" {...props}>
    {props.text || props.children}
  </IonButton>
);

export default Button;
